import { DEFAULT_COMMUNITY_SLUG } from '@highlight-cp/constants';
import { surveyApi } from '@highlight-cp/survey-api';

import { useGetCurrentProject } from '../use-get-current-project';
import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetHighlighterProfileSurveys = (communitySlugOverride?: string) => {
  const currentProjectId = useGetCurrentProjectId();
  const {
    data: project,
    isLoading: isProjectLoading,
    error: projectError,
  } = useGetCurrentProject();

  const communitySlug = communitySlugOverride ?? project?.communitySlug ?? DEFAULT_COMMUNITY_SLUG;

  const {
    data,
    isLoading: isSurveyLoading,
    error: surveyError,
  } = surveyApi.useGetHighlighterProfileSurveysQuery(
    {
      communitySlug,
    },
    { skip: !!currentProjectId && !project },
  );

  return {
    data: data ?? [],
    isLoading: isProjectLoading || isSurveyLoading,
    error: projectError || surveyError,
  };
};

export default useGetHighlighterProfileSurveys;
